import axios from 'axios';

const cloudinary_upload_url = `https://api.cloudinary.com/v1_1/${process.env.NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME}/auto/upload`;
const cloudinary_upload_headers = {
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
};

export const uploadToCloudinary = (files) => {
  // Push all the axios request promise into a single array
  const uploaders = files.map((file) => {
    // Initial FormData
    const formData = new FormData();
    formData.append('file', file);
    formData.append(
      'upload_preset',
      process.env.NEXT_PUBLIC_CLOUDINARY_UPLOAD_PRESET
    ); // Replace the preset name with your own
    formData.append('api_key', process.env.NEXT_PUBLIC_CLOUDINARY_API_KEY); // Replace API key with your own Cloudinary key

    // Make an AJAX upload request using Axios (replace Cloudinary URL below with your own)
    return axios
      .post(cloudinary_upload_url, formData, cloudinary_upload_headers)
      .then((response) => {
        const data = response.data;
        const fileURL = data.secure_url; // You should store this URL for future references in your app
        console.log('CLOUDINARY_UPLOADED_FILES', fileURL);
        return fileURL;
      })
      .catch((err) => {
        console.log('ERROR uploading files to cloudinary');
        console.log(err);
        return null;
      });
  });

  return uploaders;
};
